import * as React from "react";
import {
    Create,
    Edit,
    SimpleForm,
    TextInput,
} from 'react-admin';
import {WrappedWithBackButton} from "../wrapped-with-back-button";

const NoticeForm = () => {
    return <SimpleForm>
        <TextInput source="title" label={"Cím"} name={"title"} fullWidth required/>
        <TextInput source="content" label={"Tartalom"} name={"content"} fullWidth required/>
    </SimpleForm>
}

export const NoticeCreate = () => (
    <WrappedWithBackButton>
        <Create title={'Üzenet létrehozása'}>
            <NoticeForm/>
        </Create>
    </WrappedWithBackButton>
);

export const NoticeEdit = () => (
    <WrappedWithBackButton>
        <Edit title={'Üzenet szerkesztése'}>
            <NoticeForm/>
        </Edit>
    </WrappedWithBackButton>
);
